import 'ui-core/basic/base/js/pageBody';

UX.pageBody.on = UX.pageBody.on || {};
UX.pageBody.on.scrollTo = function ($elem, $a) {
    if (!$elem && location.hash) {
        /* we need to scroll to the top of the window first, because the browser will always jump to the anchor first before JavaScript is ready, thanks Stack Overflow: http://stackoverflow.com/a/3659116 */
        window.scrollTo(0, 0);
        const target = location.hash.split('#');

        if (target[1].split('=').length > 1) {
            UX.bookTabs.init(target[1].split('='));
            return;
        }

        $elem = $('#' + target[1]);
    }

    if ($elem && $elem.length) {
        UX.pageBody._smoothScrollTo($elem);
    }
};

UX.pageBody.on.hashTargetCheckbox = function () {
    if (location.hash) {
        const target = location.hash.split('#');
        const $elem = $('#' + target[1]);

        if ($elem.length) {
            $elem.find("input[type='checkbox']").prop('checked', true);
        }
    }
};

UX.pageBody._smoothScrollTo = function (target) {
    if (target.length) {
        let contentPaddingTop = 0;

        if ($('.header.fixed').length) {
            contentPaddingTop = $('.header.fixed').height();
        }
        if ($('.scrollThenFix.locked').length) {
            contentPaddingTop += $('.scrollThenFix.locked').height();
        }
        if ($('.fixed-element .stickybar__wrapper').length) {
            contentPaddingTop += $('.fixed-element .stickybar__wrapper').height();
        }

        $('html,body').animate(
            {
                scrollTop: target.offset().top - contentPaddingTop,
            },
            500
        );
    }
};

UX.pageBody.extraControls = function () {
    // find target from hash in URL
    UX.pageBody.on.scrollTo();
    UX.pageBody.on.hashTargetCheckbox();

    // find target from anchor tag
    $(document).on('click', 'a:not(.tab-link)[href^="#"]', function (e) {
        const role = $(this)[0].hasAttribute('role') ? $(this).attr('role') : $(this).find('[role]').attr('role');
        if (role === 'tab') return;

        const target = $(this).attr('href').split('#');
        const id = target[1].replace('.', '\\.');
        const $elem = $('#' + id);
        if ($elem.length) {
            e.preventDefault();
            UX.pageBody.on.scrollTo($elem);
            window.location.hash = target[1];
        }
    });

    $(document).ready(function () {
        if (UX.coolbar) {
            setTimeout(function () {
                UX.coolbar.headerHeight = $('header').outerHeight() || 0;
                $('.coolBar--res').addClass('trans').css('top', UX.coolbar.headerHeight);
            }, 750);
            UX.coolbar.isMobile = true;
        }
    });
};
